import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import {
  clearFreeOfChargeCategories,
  getFreeOfChargeCategories,
} from '../../../../actions/sales/FreeOfChargeCategory';

export const FreeOfChargeCategorySelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearFreeOfChargeCategories,
  dispatchGetFreeOfChargeCategories,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearFreeOfChargeCategories(), []);

  const onInputChange = (inputValue) => {
    const inputValueLength = inputValue.trim().length;

    const query = ['active:true'];

    if (inputValueLength && inputValueLength >= 4) {
      query.push(`name:${inputValue}`);
      dispatchGetFreeOfChargeCategories({ query });
    }
  };

  const filterOption = (users) => users;

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      filterOption={filterOption}
      {...rest}
    />
  );
};

FreeOfChargeCategorySelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetFreeOfChargeCategories: PropTypes.func.isRequired,
  dispatchClearFreeOfChargeCategories: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

FreeOfChargeCategorySelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por nombre',
};

const mapStateToProps = ({ SalesUnit }) => ({
  options: SalesUnit.FreeOfChargeCategory.getIn([
    'all',
    'content',
    'content',
  ]).map(({ id, name }) => ({
    value: id,
    label: name,
  })),
  loading: SalesUnit.FreeOfChargeCategory.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetFreeOfChargeCategories: getFreeOfChargeCategories,
  dispatchClearFreeOfChargeCategories: clearFreeOfChargeCategories,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FreeOfChargeCategorySelect);
